module.exports = __webpack_public_path__ + "static/img/background.4368b5a3.svg";